import { Component, OnInit } from '@angular/core';
import { DeviceDetectionService } from '../../shared/services/device-detection.service';
import { DeviceInfo } from '../../shared/models/devices/device_info';
import { appLinks } from '../../shared/app-links';

@Component({
  selector: 'app-app-not-installed',
  templateUrl: './app-not-installed.component.html',
  styleUrl: './app-not-installed.component.scss'
})
export class AppNotInstalledComponent implements OnInit {
  deviceInfo: DeviceInfo;
  showManualOptions: boolean = false;

  constructor(
    private deviceDetection: DeviceDetectionService
  ) {
    this.deviceInfo = this.deviceDetection.getDeviceInfo();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.autoRedirect();
    }, 2000);

    setTimeout(() => {
      this.showManualOptions = true;
    }, 3000);
  }

  private autoRedirect(): void {
    if (this.deviceInfo.isAndroid) {
      this.redirectToAndroidApp();
    }
    else if (this.deviceInfo.isIOS) {
      this.redirectToIOSApp();
    }
  }

  redirectToAndroidApp(): void {
    window.open(appLinks.androidAppUrl, '_blank');
  }

  redirectToIOSApp(): void {
    window.open(appLinks.iosAppUrl, '_blank');
  }
}
